import React, { useEffect, useState } from "react";
import { getMsalInstance } from "./msalConfig";

export default function MSALProviderWrapper({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const instance = getMsalInstance();
        await instance.initialize();
        setReady(true);
      } catch (err) {
      }
    };
    init();
  }, []);

  if (!ready) {
    return (
      <div id="spinner-loader">
        <div className="spinner"></div>
      </div>
    );
  }

  return children;
}
